import React from 'react';

const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Spanish' },
  { code: 'he', label: 'Hebrew' },
];

interface Props {
  value: string;
  onChange: (value: string) => void;
}

export function LanguageSelector({ value, onChange }: Props) {
  return (
    <div style={styles.container}>
      <label style={styles.label}>Language</label>
      <div style={styles.options}>
        {LANGUAGES.map((lang) => (
          <button
            key={lang.code}
            onClick={() => onChange(lang.code)}
            style={{
              ...styles.option,
              ...(value === lang.code ? styles.selected : {}),
            }}
          >
            {lang.label}
          </button>
        ))}
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: { display: 'flex', flexDirection: 'column', gap: 8 },
  label: { fontSize: 12, fontWeight: 600, color: '#888', textTransform: 'uppercase', letterSpacing: 1 },
  options: { display: 'flex', gap: 8 },
  option: {
    padding: '6px 14px',
    borderRadius: 20,
    border: '1.5px solid #ddd',
    background: '#fff',
    cursor: 'pointer',
    fontSize: 13,
    transition: 'all 0.15s',
  },
  selected: {
    borderColor: '#4f46e5',
    background: '#4f46e5',
    color: '#fff',
  },
};
